<template>
  <div class="staff-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            意见反馈
            <el-form :inline="true" size="small" :model="searchForm" style="float: right;">
              <el-form-item label="时间">
                <el-date-picker
                  v-model="searchForm.time"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="关键字">
                <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button icon="el-icon-search" type="primary" @click="Search">搜索</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="card-content">
            <el-table
              :data="tableData"
              :show-header="false"
              :row-style="{cursor: 'pointer'}"
              @row-click="getDetail"
              style="width: 100%">
              <el-table-column
                fixed
                prop="userName"
                label="姓名"
                :show-overflow-tooltip="true"
                align="center"
                width="100">
              </el-table-column>
              <el-table-column
                prop="role"
                label="用户类型"
                align="center"
                width="200">
                <template slot-scope="scope">
                  <el-tag size="small" v-if="scope.row.role===0">员工</el-tag>
                  <el-tag size="small" type="warning" v-if="scope.row.role===1">经销商</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="content"
                label="内容"
                :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column
                prop="time"
                label="时间"
                align="center"
                width="230">
                <template slot-scope="scope">
                  <span><i class="el-icon-time" />&nbsp;&nbsp;{{ scope.row.time }}</span>
                </template>
              </el-table-column>
              <el-table-column
                width="100"
                label="操作">
                <template slot-scope="scope">
                  <el-popconfirm
                    v-if="scope.row.mark===0"
                    title="发送短信通知吗?"
                    confirm-button-text="是的"
                    cancel-button-text="不用了"
                    icon="el-icon-info"
                    @onConfirm="processSend(scope.row)"
                    @onCancel="processNoSend(scope.row)">
                    <el-button slot="reference" size="mini" icon="el-icon-edit-outline">处理</el-button>
                  </el-popconfirm>
                  <el-button v-if="scope.row.mark===1" size="mini" :disabled="true">已处理</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="反馈图片"
      :visible.sync="dialog"
      width="40%">
      <el-row v-if="detail!==null" style="height:300px;">
        <el-col :span="24" style="margin-top:10px;">
          <div>
            <el-image v-for="img in detail.imgList" :key="img.id" :src="img.path" :preview-src-list="[img.path]" style="max-width: 120px;max-height: 120px;" />
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getFeedbackList, processOpinion } from '@/api/pub'

export default {
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  },
  data() {
    return {
      searchForm: {
        search: '',
        time: []
      },
      tableData: [],
      tableLoading: false,
      total: 0,
      pageSize: 20,
      currentPage: 1,
      detail: null,
      dialog: false
    }
  },
  methods: {
    getData() {
      this.tableLoading = true
      let startTime = ''
      let endTime = ''
      if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
        startTime = this.searchForm.time[0]
        endTime = this.searchForm.time[1]
      }
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        content: this.searchForm.search,
        startTime: startTime,
        endTime: endTime
      }
      getFeedbackList(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.tableLoading = false
      })
    },
    getDetail(row) {
      this.detail = row
      if (row.imgList.length === 0) {
        return false
      }
      this.dialog = true
    },
    // 搜索
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    processSend(row) {
      this.proccessOpinion(row, 1)
    },
    processNoSend(row) {
      this.proccessOpinion(row, 0)
    },
    proccessOpinion(row, isSend) {
      processOpinion({ fid: row.fid, isSend: isSend, userid: this.user.dUserid }).then(response => {
        this.$message({
          message: '处理成功',
          type: 'success'
        })
        this.getData()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .staff-container {
    &-text {
      font-size: 30px;
      line-height: 46px;
    }
  }
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          font-weight: 500;
          color: #404852;
          margin-bottom: 22px;
          font-size: 14px;
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
</style>
